/* eslint guard-for-in:0 */
/* global PortalL10n */

/**
 * PortalElementBase
 */

const {log, error} = require('./PortalLogging')
const PortalApi = require('./PortalApi')
const {l10n} = require('./PortalL10n')
const PortalUtils = require("./Utils/utils.js")
const PortalAuthenticator = require("./PortalAuthenticator");

const props = [
  'el'
]

module.exports = class PortalElementBase {

  constructor(opts={}) {
    props.forEach(prop => {if (opts[prop] === undefined) throw new Error(`Missing required prop "${prop}" for PortalElementBase`)});

    log("new PortalElementBase", opts);

    this.display = opts.parent.display;
    this.api = new PortalApi(opts.parent.api);
    delete opts.parent;

    Object.assign(this, opts.el);

    this.tplSearchResult = require('./templates/SearchResult.html');
    this.tplAggregation = require('./templates/Filters.html');
    this.tplFacetElement = require('./templates/FacetElement.html');
    this.tplCarouselOwl = require('./templates/CarouselOwl.html');
    this.tplCarouselLightSlider = require('./templates/CarouselLightSlider.html');
 
    this.limit = 50;
    this.sort = [];
    this.defaultSort = {"field": "_level", "order": "ASC"};
    this.offset = 0;

    // this property stores the facets for state management
    // must be updated everytime new facets are fetched or edited
    this.facets = {};
    this.more = true;
    this.portalUtils = new PortalUtils();
    this.sorted_languages_array = [
      "zh-Hant",
		  "zh-Hans",
		  "zh-Latn",
		  "ja-Hani",
		  "ja-Jpan",
		  "ja-Hira",
		  "ja-Kana",
		  "ja-Latn",
		  "ko-Hani",
		  "ko-Kore",
		  "ko-Hang",
		  "ko-Latn",
		  "ru-RU",
		  "en-US",
		  "de-DE"
    ];

    this.setEventsForExpandCollapse();
    this.authenticator = new PortalAuthenticator(); 
  }

  poolObjecttypeSearchPart() {
    let searchPart = {"__filter": "SearchTypeSelector","type": "complex", "bool": "must","search": []}
    let searchPartPools = {"bool": "should","type": "in","fields": []}
    this.objecttypes.forEach(element => {
      searchPartPools.fields.push(element+'._pool.pool._id')
    })
    searchPartPools.in = this.pools;
    searchPart.search.push(searchPartPools)
    let searchPartObjecttypes = {"type": "complex","bool": "should","search": []}
    let searchPartObjecttypesSearch = {"bool": "must_not","type": "in","fields": ["_objecttype"],"in": []}
    searchPartObjecttypesSearch.in = this.objecttypes
    searchPartObjecttypes.search.push(searchPartObjecttypesSearch)
    searchPart.search.push(searchPartObjecttypes)
    return searchPart
  }


  dateRangeType(bucket) {
    if (bucket.from.match(/\-01\-01$/) && bucket.to.match(/\-12\-31$/)) {
      let jf = bucket.from.match(/^\-/) ? bucket.from.substr(0,5) : '+'+bucket.from.substr(0,4)
      let jt = bucket.to.match(/^\-/) ? bucket.to.substr(0,5) : '+'+bucket.to.substr(0,4)
      if (jf == jt) {
        return 'jahr'
      }
      else if ((jf.substr(2,3) == '000' || jf.substr(2,3) == '001') && jt.substr(2,3) == '999' && jf.substr(0,1) == '+' && jf.substr(0,2) == jt.substr(0,2)) {
        return 'jahrtausend'
      }
      else if (jf.substr(2,3) == '999' && (jt.substr(2,3) == '000' || jt.substr(2,3) == '001') && jf.substr(0,1) == '-' && jf.substr(0,2) == jt.substr(0,2)) {
        return 'jahrtausend'
      }
      else if ((jf.substr(3,2) == '00' || jf.substr(3,2) == '01') && jt.substr(3,2) == '99' && jf.substr(0,3) == jt.substr(0,3)) {
        return 'jahrhundert'
      }
      else if (jf.substr(3,2) == '99' && (jt.substr(3,2) == '00' || jt.substr(3,2) == '01') && jf.substr(0,1) == '-' && jf.substr(0,3) == jt.substr(0,3)) {
        return 'jahrhundert'
      }
      else if (jf.substr(4,1) == '0' && jt.substr(4,1) == '9' && jf.substr(0,4) == jt.substr(0,4)) {
        return 'jahrzehnt'
      }
      else if (jf.substr(4,1) == '9' && jt.substr(4,1) == '0' && jf.substr(0,1) == '-' && jf.substr(0,4) == jt.substr(0,4)) {
        return 'jahrzehnt'
      }
      else {
        return 'jahresbereich'
      }
    }
    return 'datumsbereich'
  }

  dateRangeDisplay(bucket) {
    let disp = ''
    //disp = bucket.from.substr(0,10)+' - '+bucket.to.substr(0,10)
    disp = bucket.from+' - '+bucket.to
    // Ober-/Untergrenze
    if (bucket.from == '-9999-01-01') {
      disp = bucket.to.replace(/\-12\-31$/,'')
      if (disp.match(/^\-/)) {
        disp = disp.substr(1)+' '+l10n('v.Chr.', PortalL10n.lang)
      }
      disp = '<= '+disp
      return disp
    }
    if (bucket.to == '9999-12-31') {
      disp = bucket.from.replace(/\-01\-01$/,'')
      if (disp.match(/^\-/)) {
        disp = disp.substr(1)+' '+l10n('v.Chr.', PortalL10n.lang)
      }
      disp = '>= '+disp
      return disp
    }

    let type = this.dateRangeType(bucket)
    if (type == 'jahr') {disp = bucket.from.substr(0,4)}
    else if (type == 'jahrtausend') {
      let jt = bucket.from.substr(0,1) == '-' ? parseInt(bucket.from.substr(1,1))+1 : parseInt(bucket.from.substr(0,1))+1
      disp = jt+'. '+l10n('Jahrtausend', PortalL10n.lang)
      if (bucket.from.substr(0,1) == '-') {disp += ' '+l10n('v.Chr.', PortalL10n.lang)}
    }
    else if (type == 'jahrhundert') {
      let jhd = bucket.from.substr(0,1) == '-' ? parseInt(bucket.from.substr(1,2))+1 : parseInt(bucket.from.substr(0,2))+1
      disp = jhd+'. '+l10n('Jahrhundert', PortalL10n.lang)
      if (bucket.from.substr(0,1) == '-') {disp += ' '+l10n('v.Chr.', PortalL10n.lang)}
    }
    else if (type == 'jahrzehnt') {
      let jz = bucket.from.substr(0,1) == '-' ? parseInt(bucket.from.substr(1,3)) : parseInt(bucket.from.substr(0,3))
      disp = jz+'0'+l10n('Jahrzehnt', PortalL10n.lang)
      if (bucket.from.substr(0,1) == '-') {disp += ' '+l10n('v.Chr.', PortalL10n.lang)}
    }
    else if (type == 'jahrsbereich') {
      disp = bucket.from.substr(0,1) == '-' ? bucket.from.substr(1,4)+' '+l10n('v.Chr.', PortalL10n.lang) : bucket.from.substr(0,4)+' - '
      disp += bucket.to.substr(0,1) == '-' ? bucket.to.substr(1,4)+' '+l10n('v.Chr.', PortalL10n.lang) : bucket.to.substr(0,4)
    }

    return disp
  }

  resultFrontendLang(result) {
    result.objects.forEach(o => {
      // Standard in Portal-Sprache?
      if (typeof(o['_standard']['1']['html'][PortalL10n.lang]) != 'undefined') {
        o['_standard']['1']['html']['frontend'] = o['_standard']['1']['html'][PortalL10n.lang]
      }
      // Standard in Default-Sprache?
      else if (typeof(o['_standard']['1']['html'][PortalL10n.defaultlang]) != 'undefined') {
        o['_standard']['1']['html']['frontend'] = o['_standard']['1']['html'][PortalL10n.defaultlang]
      }
      // Alle Sprachen durchprobieren
      else {
        Object.keys(PortalL10n.langcode).forEach(l => {
          if (typeof(o['_standard']['1']['html'][l]) != 'undefined') {
            o['_standard']['1']['html']['frontend'] = o['_standard']['1']['html'][l]
          }
        })
      }
      if (typeof(o['_standard']['2']) != 'undefined') {
        // Standard in Portal-Sprache?
        if (typeof(o['_standard']['2']['html'][PortalL10n.lang]) != 'undefined') {
          o['_standard']['2']['html']['frontend'] = o['_standard']['2']['html'][PortalL10n.lang]
        }
        // Standard in Default-Sprache?
        else if (typeof(o['_standard']['2']['html'][PortalL10n.defaultlang]) != 'undefined') {
          o['_standard']['2']['html']['frontend'] = o['_standard']['2']['html'][PortalL10n.defaultlang]
        }
        // Alle Sprachen durchprobieren
        else {
          Object.keys(PortalL10n.langcode).forEach(l => {
            if (typeof(o['_standard']['2']['html'][l]) != 'undefined') {
              o['_standard']['2']['html']['frontend'] = o['_standard']['2']['html'][l]
            }
          })
        }
      }
      else {o['_standard']['2'] = {html: {frontend: ''}}}

      o['asset'] = {}
      o['asset']['original_filename_basename'] = '' 
      o['asset']['url'] = ''
      try {
        o['asset']['original_filename_basename'] = o['_standard']['eas'][1][0]['original_filename_basename']
      }
      catch (e) {}
      try {
        o['asset']['url'] = o['_standard']['eas'][1][0]['versions']['small']['url'] 
      }
      catch (e) {}
      o['asset']['thumburl'] = ''
      try {
        o['asset']['thumburl'] = o['_standard']['eas'][1][0]['versions']['small']['url']
      }
      catch (e) {}
      o['asset']['width'] = 0
      try {
        o['asset']['width'] = o['_standard']['eas'][1][0]['versions']['small']['width']
      }
      catch (e) {}
      try {
        if (typeof(this.assetPath) == 'object' && typeof(this.assetSize) != 'undefined') {
          let pointer = o
          this.assetPath.forEach(p => {
            pointer = pointer[p]
          })
          // "preferred asset version" ermitteln
          pointer['asset'].forEach(p => {
            if (p['preferred'] == true) {
              o['asset']['url'] = p['versions'][this.assetSize]['url']
              o['asset']['width'] = p['versions'][this.assetSize]['width']
            }
          })
        }
      }
      catch (e) {}
      try {
        o['asset']['image_class_url'] = ''
        let image_obj = o['_standard']['eas'][1].filter(resource_obj => {
          let exists = resource_obj['versions']['small'] ? resource_obj['versions']['small']['class'] ? resource_obj['versions']['small']['class'] === 'image' : false : false
          return exists
        })
        o['asset']['image_class_url'] = image_obj[0]['versions']['small']['url']
      }
      catch (e) {}

      o['objekte']['all_sorted_obj_titels'] = [];
      this.sorted_languages_array.forEach(lang => {
        if (o['objekte']['obj_titel'][lang]) {
          var new_title_obj = {};
          new_title_obj[lang] = o['objekte']['obj_titel'][lang];
          o['objekte']['all_sorted_obj_titels'].push(new_title_obj);
        }
      })

    })
    return result
  }

  renderCarousel(result) {
    let template = (typeof(this.carouselType) != 'undefined' && this.carouselType == 'lightslider') ? Handlebars.compile(this.tplCarouselLightSlider) : Handlebars.compile(this.tplCarouselOwl)
    let content = template({result: this.resultFrontendLang(result), display: this.display, lang: PortalL10n.lang, l10n: {'linktext': l10n('linktext', PortalL10n.lang)}})
    return content
  }

  renderObjects(result) {
    let template = Handlebars.compile(this.tplSearchResult)
    let content = template({result: this.resultFrontendLang(result), display: this.display})
    return content 
  }

  renderAggregations(result, more, moreOptionPressed=false) {

    let old_state = structuredClone(this.facets);
    let facetTree = {}

    for (var field in result.aggregations) {
      let fieldkey = field.replace(/:[\d\.]+$/,'').replace(/:range_\-?\d\d\d\d_.*$/,'')
      facetTree[fieldkey] = {}
      facetTree[fieldkey].children = []         
      facetTree[fieldkey].treeElements = {}
    }

    for (var field in result.aggregations) {
      let fieldkey = field.replace(/:[\d\.]+$/,'').replace(/:range_\-?\d\d\d\d_.*$/,'')
      // console.log("FIELD KEY" + fieldkey)

      facetTree[fieldkey].display = typeof(this.searchFilters[fieldkey]) != 'undefined' ? true : false;
      facetTree[fieldkey].title = this.aggregations[fieldkey].title; 
      facetTree[fieldkey].type = this.aggregations[fieldkey].type;
      facetTree[fieldkey].has_more = (typeof result.aggregations[field].has_more != 'undefined' && result.aggregations[field].has_more) ? true : false;
      facetTree[fieldkey].title_suffix = typeof this.aggregations[fieldkey].title_suffix != 'undefined' ? this.aggregations[fieldkey].title_suffix : null;
     
      // Term-Facette
      if (facetTree[fieldkey].type == 'term' || facetTree[fieldkey].type == 'asset') {
        facetTree[fieldkey].terms_selected = []
        facetTree[fieldkey].terms_selectable = []

        if (typeof result.aggregations[field].terms != 'undefined') {facetTree[fieldkey].display = true}

        result.aggregations[field].terms.forEach(t => {
          let found = false
          if (field == '_objecttype' || field == '_eas') {
            if (typeof(this.easydb_l10n['schema.'+t.term+'.name']) != 'undefined') {
              t.term_l10n = this.easydb_l10n['schema.'+t.term+'.name'][PortalL10n.lang]
            }
          }
          if (typeof(this.searchFilters[field]) != 'undefined') {
            this.searchFilters[field].forEach(sf => {
              if (t.term == sf) {found = true}
            })
          }
          if (found) {
            facetTree[fieldkey].terms_selected.push(t)
          }
          else {
            facetTree[fieldkey].terms_selectable.push(t)
          }
        })
      }
      // Linked-Object-Facette
      else if (facetTree[fieldkey].type == 'linked_object') {
        if (typeof result.aggregations[field].linked_objects != 'undefined' && result.aggregations[field].linked_objects.length >= 0) {facetTree[fieldkey].display = true}
        let hierarchy = typeof(this.aggregations[fieldkey].filter_parent) != 'undefined' || this.aggregations[fieldkey].filter_parent != null ? true : false;
        if (!hierarchy) {
          facetTree[fieldkey].objects_selected = []
          facetTree[fieldkey].objects_selectable = []
        }
        // alle linked objects verarbeiten
        result.aggregations[field].linked_objects.forEach(lo => {
          // linked object hierarchisch
          if (hierarchy) {
            let pointer = facetTree[fieldkey]
            let key = ''
            if (typeof(this.searchFilters[fieldkey]) != 'undefined') {
              if (this.filterChanged[fieldkey]) {
                facetTree[fieldkey].active = 1
              }
            }
            lo._path.forEach(lop => {
              if (typeof(facetTree[fieldkey].treeElements[lop._id]) == 'undefined') {facetTree[fieldkey].treeElements[lop._id] = {}}
              if (key != '') {key += '.'}
              key += lop._id
              facetTree[fieldkey].treeElements[lop._id].key = key
              facetTree[fieldkey].treeElements[lop._id].text = lop.text
              let index = -1 
              let foundindex = -1
              pointer.children.forEach(c => {
                index++
                if (c.id == lop._id) {foundindex = index}
              })
              if (foundindex >= 0) {
                pointer = pointer.children[foundindex]
              }
              else {
                let child = { id: lop._id, children: [], element: facetTree[fieldkey].treeElements[lop._id] }
                if ( this.searchFilters[fieldkey] != undefined && this.searchFilters[fieldkey].filter(sf => { return sf.split(".").includes(`${lop._id}`) }).length ) {
                  child["isSelected"] = true;
                }
                pointer.children.push(child);
                pointer = pointer.children[pointer.children.length - 1];
              }
            })
            facetTree[fieldkey].treeElements[lo._path[lo._path.length - 1]._id].count = lo.count
          }
          // linked object nicht hierarchisch
          else {
            let found = false
            if (typeof(this.searchFilters[field]) != 'undefined') {
              this.searchFilters[field].forEach(sf => {
                if (lo._id == sf) {found = true}
              })
            }
            if (found) {
              facetTree[fieldkey].objects_selected.push(lo)
            }
            else {
              facetTree[fieldkey].objects_selectable.push(lo)
            }
          }
        })


      }
      // Date-Range-Facette
      else if (facetTree[fieldkey].type == 'date_range') {
        let hierarchy = typeof(this.aggregations[fieldkey].filter_parent) != 'undefined' ? true : false

        facetTree[fieldkey].buckets_selected = []
        facetTree[fieldkey].buckets_selectable = []
        // alle buckets verarbeiten
        if (typeof result.aggregations[field].buckets != 'undefined') {
          if (typeof(this.searchFilters[fieldkey]) != 'undefined') {
            if (this.filterChanged[fieldkey]) {
              facetTree[fieldkey].active = 1
            }
          }

          let path = []	
          let field_hier = field
          while (field_hier.match(/:range_\-?\d\d\d\d_\-?\d\d\d\d$/)) {
            field_hier = field_hier.replace(/:range_\-?\d\d\d\d_\-?\d\d\d\d$/, (x) => {
              path.unshift(x.substr(7))
              return ''
            })
          }
          path.forEach(p =>{
            let f = p.replace(/_.*$/,'')+'-01-01'
            let t = p.replace(/^.*_/,'')+'-12-31'
            facetTree[fieldkey].buckets_selected.push({key: f+'-'+t, from: f, to: t, display: this.dateRangeDisplay({from: f, to: t})})
          })

          result.aggregations[field].buckets.forEach((bu, index) => {
            facetTree[fieldkey].display = true;
            if (bu.doc_count > 0) {
              bu.display = this.dateRangeDisplay(bu);
              facetTree[fieldkey].buckets_selectable.push(bu);
            }
          })
        }
      }
      else {
        // ToDo ???
      }
    }
  
    this.facets = this.replaceOrCreateFacets(facetTree, this.facets);
    this.more = more;
    // Check if Reload/Aggregations Render is being done after More Options Pressed
    if (moreOptionPressed == false) {
      // If not, then set default collapse-expansion of each facet
      this.setFacetExpandCollapse(this.facets, old_state);
    } else {
      // Otherwise if more options is pressed, then set isExpanded key of facet to true for result facet. 
      // This will expand the facet for which more option is pressed, Instead of it's default expand-collapse behaviour.
      Object.keys(facetTree).forEach(facetName => {
        this.facets[facetName].isExpanded = true;
      });
    }

    this.facets = this.checkIfFacetsMaxLimitReached(this.facets);
    return this.loadInTemplate(this.facets, more);

  }

  loadInTemplate(facetTree, more) {
    let template = Handlebars.compile(this.tplAggregation)
    this.registerHandleBarsHelpers();

    let out = ''
    let sortable = [];
    for (var fT in facetTree) {
      sortable.push([fT,typeof(this.aggregations[fT].index) != 'undefined' ? this.aggregations[fT].index : 0])
    }
    sortable.sort(function(a, b) {
      return a[1] - b[1]
    })
    sortable.forEach(item => {
      let purl = ''
      if (this.purl && typeof(this.aggregations[item[0]].index) != 'undefined') {
        purl = this.purl+'#filter:'+this.aggregations[item[0]].index+':'
        if (typeof(this.searchFilters[item[0]]) != 'undefined' && this.searchFilters[item[0]].length) {
          // bei hierarchischen Filtern mit linked Object, nur tiefstes Element
          // aufführen => kürzere URLs (parents werden beim Aufruf ergänzt)
          if (typeof(this.aggregations[item[0]].filter_parent) != 'undefined' && this.aggregations[item[0]].type == 'linked_object') {
            let max_depth_el = ''
            let max_depth = 0
            this.searchFilters[item[0]].forEach(el => {
              let temp = el.split('.')
              if (el.length > max_depth) {
                max_depth_el = el
                max_depth = el.length
              }
            })
            if (max_depth_el) {
              purl += JSON.stringify([max_depth_el])
            }
            else {
              purl += JSON.stringify(this.searchFilters[item[0]])
            }
          }
          else {
            purl += JSON.stringify(this.searchFilters[item[0]])
          }
        }
        else {purl = ''}
      }
      out += template({
        key: item[0], 
        facet: facetTree[item[0]], 
        purl: purl, 
        changed: this.filterChanged[item[0]], 
        more: more, 
        lang: PortalL10n.lang, 
        l10n: {
          reset_all: l10n('reset_all', 
          PortalL10n.lang),
          mehr: l10n('mehr', 
          PortalL10n.lang),
          purl: l10n('Persistente URL', 
          PortalL10n.lang)
      }})
    })
    return out
  }

  registerHandleBarsHelpers() {
    Handlebars.registerPartial('facetElement', this.tplFacetElement)
    Handlebars.registerHelper('langText', function(t, l, options) {
      if (typeof(t) == 'undefined') {return ''}
      if (typeof(t[l]) != 'undefined') {return t[l]}
      else {
        if (typeof(t['de-DE']) != 'undefined') {return t['de-DE']}
        else {return ''}
      }
    });
    Handlebars.registerHelper('ifCond', function(v1, v2, options) {
      if(v1 === v2) {
        return options.fn(this) 
      }
      return options.inverse(this) 
    });
    Handlebars.registerHelper('isdefined', function (value1) {
      return value1 !== undefined;
    });
    Handlebars.registerHelper('consolelog', function (value) {
      return true;
    });
    Handlebars.registerHelper('SHOULDIGNORE', function (value1) {
      return value1.toLowerCase() === "all pools" ? true: false;
    });
    Handlebars.registerHelper('isselected', function (value1) {
      let isSelected = value1.isSelected;
      // OR condition handles special case for selected publisher.
      return isSelected;
    });
    Handlebars.registerHelper('shouldIndentToRight', function (value1, value2) {
      if (value2.children.length) {
        return false
      } else {
        return value1 === 'selected' && !value2.isSelected
      }
    });
    Handlebars.registerHelper('shouldShowFacet', function (value1) {
      let shouldShow = false;
      if (value1.terms_selected != undefined && value1.terms_selected.length) {
        shouldShow = true;
      } else if (value1.objects_selected != undefined && value1.objects_selected.length) {
        shouldShow = true;
      } else if (value1.buckets_selected != undefined && value1.buckets_selected.length) {
        shouldShow = true;
      } else if (value1.terms_selectable != undefined && value1.terms_selectable.length) {
        shouldShow = true;
      } else if (value1.objects_selectable != undefined && value1.objects_selectable.length) {
        shouldShow = true;
      } else if (value1.buckets_selectable != undefined && value1.buckets_selectable.length) {
        shouldShow = true;
      } else if (value1.children != undefined && value1.children.length) {
        shouldShow = true;
      } else {
        shouldShow = false;
      }
      return shouldShow;
    });
  }

  setFacetExpandCollapse(facetTree, old_facets) {
    // Set Facet isExpanded to it's old value / earlier stage or set it to default state if faacet is not found in old facets 
    Object.keys(facetTree).forEach((facetName, index) => {

      if (old_facets[facetName] != undefined) {
        facetTree[facetName].isExpanded = old_facets[facetName].isExpanded;
      } else {
        facetTree[facetName].isExpanded = this.getDefaultExpansionForFacets(facetName);
      }
    });
  }

  getDefaultExpansionForFacets(facetName) {
    let defaultVal = true;
    let facetsValue = {
      "objekte._nested:objekte__obj_herstellungsorte.obj_herstellungsort_gnd.conceptName": {
        isExpanded: false
      },
      "objekte._nested:objekte__obj_autoren_lok.obj_autor_lok/lokal_klass_person": {
        isExpanded: false
      },
      "objekte._nested:objekte__obj_sprachen.obj_sprache_gnd.conceptName": {
        isExpanded: false
      },
      "objekte.obj_datierung_norm.from": {
        isExpanded: false
      },
      "objekte._nested:objekte__obj_verlag_lok.obj_verlag_lok/lokal_klass_verlag": {
        isExpanded: false
      }
    };
    return facetsValue[facetName] != undefined ? facetsValue[facetName].isExpanded : defaultVal;
  }

  setEventsForExpandCollapse() {

    PortalEvent.on("collapseFacet", (e, target, filter, clickEventsAggreg) => {
      let filterName = filter.closest("[data-aggreg]").data("aggreg");
      if (this.facets[filterName] != undefined) {
        this.facets[filterName].isExpanded = false;
      }
      this.reloadTemplateWithNewClickEvents();
    });

    PortalEvent.on("expandFacet", (e, target, filter, clickEventsAggreg) => {
      let filterName = filter.closest("[data-aggreg]").data("aggreg");
      if (this.facets[filterName] != undefined) {
        this.facets[filterName].isExpanded = true;
      }
      this.reloadTemplateWithNewClickEvents();
    });

  }


  reloadTemplateWithNewClickEvents() {
    this.loadInTemplate(this.facets, this.more);
    this.reloadAggregations();
    PortalEvent.emit("setClickEventsAfterReload");
  }

  reloadAggregations() {
    $(this.target)
      .find('[data-function="ep-aggregations"]')
      .html("<div>" + this.loadInTemplate(this.facets, this.more) + "</div>");
  }

  // Updates state of existing Facets by creating new facets or replace existing facets 
  // with their new values after (For example: "More option is selected and new Facets options are fetched.")
  replaceOrCreateFacets(newFacets, oldFacets) {
    Object.keys(newFacets).forEach(facetName => {
        oldFacets[facetName] = newFacets[facetName];
    });
    return oldFacets;
  }

  checkIfFacetsMaxLimitReached(facetTree) {

    Object.keys(facetTree).forEach(facetName => {
      if (facetTree[facetName].has_more) {
        
        let max_limit = this.portalUtils.getMaxLimitForExpansion(facetName);
        facetTree[facetName].is_max_limit_reached = false;
        
        if (facetTree[facetName].terms_selectable != undefined && facetTree[facetName].terms_selectable.length == max_limit) {
          facetTree[facetName].is_max_limit_reached = true;
          facetTree[facetName].show_less_button = true;
        } else if (facetTree[facetName].children != undefined && facetTree[facetName].children.length == max_limit) {
          facetTree[facetName].is_max_limit_reached = true;
          facetTree[facetName].show_less_button = true;
        } else if (facetTree[facetName].objects_selectable != undefined && facetTree[facetName].objects_selectable.length == max_limit) {
          facetTree[facetName].is_max_limit_reached = true;
          facetTree[facetName].show_less_button = true;
        } else if (facetTree[facetName].buckets_selectable != undefined && facetTree[facetName].buckets_selectable.length == max_limit) {
          facetTree[facetName].is_max_limit_reached = true;
          facetTree[facetName].show_less_button = true;
        } else {
          facetTree[facetName].is_max_limit_reached = false;
          facetTree[facetName].show_less_button = false;
        }

      } else {
        facetTree[facetName].is_max_limit_reached = false;
        
        if (facetTree[facetName].terms_selectable != undefined && facetTree[facetName].terms_selectable.length > this.aggregations[facetName].limit) {
          facetTree[facetName].show_less_button = true;
        } else if (facetTree[facetName].children != undefined && facetTree[facetName].children.length > this.aggregations[facetName].limit) {
          facetTree[facetName].show_less_button = true;
        } else if (facetTree[facetName].objects_selectable != undefined && facetTree[facetName].objects_selectable.length > this.aggregations[facetName].limit) {
          facetTree[facetName].show_less_button = true;
        } else if (facetTree[facetName].buckets_selectable != undefined && facetTree[facetName].buckets_selectable.length > this.aggregations[facetName].limit) {
          facetTree[facetName].show_less_button = true;
        } else {
          facetTree[facetName].show_less_button = false;
        }

      }

    });

    return facetTree;

  }

}



//////////////////
// WEBPACK FOOTER
// ./js/PortalElementBase.js
// module id = 6
// module chunks = 0